import { render, staticRenderFns } from "./FormGeneralKasbon.vue?vue&type=template&id=6c51877c"
import script from "./FormGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./FormGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports